import { UntypedFormControl, ValidatorFn } from "@angular/forms";
import moment from "moment";

export function minMaxAgeValidator(
  minAge?: number,
  maxAge?: number,
): ValidatorFn {
  return (control: UntypedFormControl): Record<string, boolean> | null => {
    const age = moment().diff(control.value, "years", true);

    if (minAge != null && age < minAge) {
      return { min: true };
    }

    if (maxAge != null && age > maxAge + 1) {
      return { max: true };
    }

    return null;
  };
}
